module.exports = __webpack_public_path__ + "static/media/RemoteHealthMonitoringProtected.c11256a0.png";